// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Accordion_wrap__3jwwU","header":"Accordion_header__3rD3o","openIcon":"Accordion_openIcon__2zOgr","body":"Accordion_body__1JEQk"};